import React from "react";
import { CalendarDays, X, ExternalLink } from "lucide-react";
import { INK, INK_2, INK_3, LINE, BURGUNDY, BURGUNDY_TINT } from "../../Bureau/bureauTokens";

const JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

function labelJour(d) {
  return isNaN(d) ? "" : `${JOURS[d.getDay()]} ${d.getDate()} ${MOIS[d.getMonth()]}`;
}

// Modal centrée (même pattern que RoomBookingDetailModal.jsx) : détail d'un
// RDV cliqué dans la grille "Rendez-vous" — `rdv` vient soit de googleEvents
// (a htmlLink → lien "Ouvrir dans Google Calendar"), soit de internalTimed
// (Evenement "Demande de rdv", pas de htmlLink) — voir Planning.jsx#openEvent.
function RdvDetailModal({ rdv, onClose }) {
  const d = new Date(rdv.date);

  return (
    <div className="fixed inset-0 z-[210] flex items-center justify-center p-4" style={{ background: "rgba(31,22,32,.45)" }} onClick={onClose}>
      <div
        className="w-full flex flex-col overflow-hidden"
        style={{ maxWidth: 440, background: "#fff", borderRadius: 18, boxShadow: "0 24px 60px rgba(20,14,24,.30)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3.5 px-5 py-4 flex-shrink-0" style={{ borderBottom: `1px solid ${LINE}` }}>
          <div
            className="flex items-center justify-center flex-shrink-0"
            style={{ width: 40, height: 40, borderRadius: 10, background: BURGUNDY_TINT, color: rdv.color || BURGUNDY }}
          >
            <CalendarDays size={19} />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-sm font-semibold m-0 truncate" style={{ color: INK }}>
              {rdv.client}
            </h2>
            <div className="text-[11px] mt-0.5 capitalize" style={{ color: INK_3 }}>
              {labelJour(d)} · {rdv.time} · {rdv.dur} min
            </div>
          </div>
          <button onClick={onClose} className="flex items-center justify-center flex-shrink-0" style={{ width: 32, height: 32, borderRadius: 8, border: `1px solid ${LINE}` }}>
            <X size={14} style={{ color: INK_2 }} />
          </button>
        </div>

        <div className="px-5 py-4 flex flex-col gap-3">
          <span
            className="self-start text-[11px] font-bold px-2.5 py-1"
            style={{ borderRadius: 20, background: `${rdv.color || BURGUNDY}22`, color: rdv.color || BURGUNDY }}
          >
            {rdv.canal}
          </span>
          {rdv.motif ? (
            <p className="text-xs leading-relaxed m-0" style={{ color: INK_2 }}>
              {rdv.motif}
            </p>
          ) : (
            <p className="text-xs italic m-0" style={{ color: INK_3 }}>
              Aucune description
            </p>
          )}
        </div>

        <div className="flex items-center justify-end gap-2 px-5 py-3.5 flex-shrink-0" style={{ borderTop: `1px solid ${LINE}`, background: "#FAFAF8" }}>
          {rdv.htmlLink && (
            <a
              href={rdv.htmlLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 px-4 py-2 text-xs font-semibold"
              style={{ border: `1px solid ${LINE}`, borderRadius: 10, color: INK }}
            >
              <ExternalLink size={13} /> Ouvrir dans Google Calendar
            </a>
          )}
          <button
            onClick={onClose}
            className="px-4 py-2 text-xs font-semibold text-white"
            style={{ background: BURGUNDY, borderRadius: 10 }}
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}

export default RdvDetailModal;
